// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-radio[data-v-29edbf6a]{border:1px solid gray;border-radius:5px;margin-bottom:3px;margin-top:3px}.v-sheet.v-stepper[data-v-29edbf6a]:not(.v-sheet--outlined){box-shadow:none!important}@media (min-width:1024px){.v-radio[data-v-29edbf6a]{padding:10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
